window['ThemeModule_Model'] = () => {
  return {
    enabled: false,
    modelViewerUI: null,
    modelId: null,
    _init() {
      this.enabled = true;

      this.$nextTick(() => {
        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: (errors) => {
              if (errors) return;

              // Verifica que el elemento model-viewer exista
              const modelViewerElement = this.$root.querySelector('model-viewer');
              if (modelViewerElement) {
                this.modelViewerUI = new Shopify.ModelViewerUI(modelViewerElement);
              } else {
                console.error('model-viewer element not found');
              }
            },
          },
        ]);
      });

      this.productMediaWrapper = this.$root.closest(
        '[data-product-single-media-wrapper]'
      );

      if (this.productMediaWrapper) {
        this.modelId =
          this.productMediaWrapper.dataset.productSingleMediaWrapper;
        this.setUpProductMediaListeners();
      }
    },
    setUpProductMediaListeners() {
      this.productMediaWrapper.addEventListener('mediaHidden', () => {
        this.pause();
      });

      this.productMediaWrapper.addEventListener('xrLaunch', () => {
        this.pause();
      });

      this.productMediaWrapper.addEventListener('mediaVisible', () => {
        this.setXRButton();
        if (window.isTouch()) return;
        this.play();
      });
    },
    setXRButton() {
      const productRoot = this.$root.closest('[data-product]');
      const xrButton = productRoot ? productRoot.querySelector('[data-shopify-xr]') : null;

      if (!productRoot || !xrButton) return;

      xrButton.setAttribute('data-shopify-model3d-id', this.modelId);
    },
    pause() {
      if (!this.modelViewerUI) return;

      Alpine.raw(this.modelViewerUI).pause();
    },
    play() {
      if (!this.modelViewerUI) return;

      Alpine.raw(this.modelViewerUI).play();
    },
  };
};
